import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import "./Mobility.css";
import { Smartphone, Shield, WifiOff, Camera, Zap, ClipboardCheck, Package, Wrench } from "lucide-react";
import { FaMobileAlt, FaWarehouse, FaTools } from "react-icons/fa";
import mobile from "../../assets/mobile.png";

export default function Mobility() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="mobility-page-content">
        {/* Hero Section */}
        <section
          className="mobility-hero"
           style={{ backgroundImage: `url(${mobile})` }}
        >
          <div className="mobility-hero-overlay"></div>
          <h1 className="mobility-hero-title">
            Unleash the Power of Mobile-First Manufacturing: Access Your ERP Anytime, Anywhere
          </h1>
        </section>

        {/* Intro Section */}
        <section className="mobility-intro">
          <h2>Empower Your Workforce with Mobile ERP Access</h2>
          <p>
            Mobility in Manufacturing ERP extends enterprise data and functionality to smartphones,
            tablets, and rugged handheld devices — allowing employees to work efficiently at the
            point of activity. From the shop floor to field service, mobile ERP ensures instant access
            to accurate, real-time data, eliminating bottlenecks and improving responsiveness.
          </p>
        </section>

        {/* Key Components */}
        <section className="mobility-components">
          <h2>Key Components of Our Mobile ERP Solution</h2>
          <div className="mobility-component-list">
            <div className="mobility-component">
              <Smartphone className="mobility-icon" />
              <h3>Native Mobile Applications</h3>
              <p>
                High-performance apps for iOS and Android with intuitive interfaces, designed for
                manufacturing environments with large buttons and streamlined workflows.
              </p>
            </div>

            <div className="mobility-component">
              <Shield className="mobility-icon" />
              <h3>Role-Based Access & Security</h3>
              <p>
                Workers see only the data and functions relevant to their roles, protected by
                enterprise-grade authentication and encryption.
              </p>
            </div>

            <div className="mobility-component">
              <WifiOff className="mobility-icon" />
              <h3>Offline Capability</h3>
              <p>
                Capture data even in low-connectivity environments. Offline records sync seamlessly
                once a network connection is restored.
              </p>
            </div>

            <div className="mobility-component">
              <Camera className="mobility-icon" />
              <h3>Integration with Device Hardware</h3>
              <p>
                Use device features like cameras for barcode scanning, GPS for asset tracking, and
                touchscreen signatures for quick validation.
              </p>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="mobility-benefits">
          <h2>Core Benefits of Implementing Mobile ERP</h2>

          <div className="mobility-benefit-item">
            <Zap className="mobility-benefit-icon" />
            <div>
              <h3>Accelerate Data Accuracy & Timeliness</h3>
              <p>
                Eliminate manual paperwork—scan and input data directly at the source for instant
                updates, improving accuracy and visibility across operations.
              </p>
            </div>
          </div>

          <div className="mobility-benefit-item">
            <ClipboardCheck className="mobility-benefit-icon" />
            <div>
              <h3>Maximize Shop Floor Efficiency</h3>
              <p>
                Technicians access work orders, maintenance schedules, and documentation directly
                from tablets—reducing downtime and walking time.
              </p>
            </div>
          </div>

          <div className="mobility-benefit-item">
            <Package className="mobility-benefit-icon" />
            <div>
              <h3>Enhance Inventory & Warehouse Management</h3>
              <p>
                Enable rapid barcode/RFID scanning for receiving, picking, and cycle counting,
                reducing stock discrepancies and improving warehouse accuracy.
              </p>
            </div>
          </div>

          <div className="mobility-benefit-item">
            <Shield className="mobility-benefit-icon" />
            <div>
              <h3>Streamline Quality and Compliance</h3>
              <p>
                Inspectors can log digital forms, capture photos, and initiate non-conformance
                reports instantly, ensuring real-time visibility and traceability.
              </p>
            </div>
          </div>

          <div className="mobility-benefit-item">
            <Wrench className="mobility-benefit-icon" />
            <div>
              <h3>Improve Field Service & Maintenance</h3>
              <p>
                Field technicians access equipment data, service history, and spare parts info
                on-site—boosting first-time fix rates and service efficiency.
              </p>
            </div>
          </div>
        </section>

        {/* Applications Section */}
    {/* --- Key Applications (Dark Gradient, Fixed & Aligned) --- */}
<section className="mobility-applications">
  <h2>Key Mobile ERP Applications</h2>
  <div className="application-list">
    
    <div className="application-row">
      <div className="app-text">
        <h3>Mobile Work Order Execution</h3>
        <p>
          Operators can view and update work orders, log time, report
          quantities, track scrap, and request materials — all from their
          mobile devices for instant ERP updates.
        </p>
      </div>
      <div className="app-icon">
        <FaMobileAlt className="app-icon-style" />
      </div>
    </div>

    <div className="application-row reverse">
      <div className="app-text">
        <h3>Warehouse & Logistics Scanning</h3>
        <p>
          Use mobile scanners to confirm shipments, manage material movements,
          and perform real-time cycle counts synced directly with ERP stock data.
        </p>
      </div>
      <div className="app-icon">
        <FaWarehouse className="app-icon-style" />
      </div>
    </div>

    <div className="application-row">
      <div className="app-text">
        <h3>Mobile Asset Management & Maintenance</h3>
        <p>
          Technicians scan QR codes on equipment to access service history,
          log conditions, and create maintenance work orders on the go —
          reducing downtime and paperwork.
        </p>
      </div>
      <div className="app-icon">
        <FaTools className="app-icon-style" />
      </div>
    </div>

  </div>
</section>



        {/* Closing Impact */}
        <section className="mobility-impact">
          <h2>Empower Manufacturing Mobility</h2>
          <p>
            With Mobile ERP, your workforce gains the agility and visibility to act instantly—anytime,
            anywhere. Enable real-time decision-making, faster workflows, and a truly connected
            enterprise.
          </p>
        </section>
      </div>
      <ERPChatbot />
      <Footer />
    </>
  );
}
